module.exports = __webpack_public_path__ + "static/media/buy_req_help_5.b68ad775.png";